import React, { useState } from "react"
import { CompanyDetailCard } from "../../molecules"
import { ICompanyDetailCard } from "../../molecules/CompanyDetailCard"
import styled from "styled-components"

interface ICompanyDetailGrid {
  items: Array<ICompanyDetailCard>
}

const Wrapper = styled.div`
  width: 1056px;
  margin: auto;
  @media (max-width: 1115px) {
    width: 100%;
  }
`

const GridStyle = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  @media (max-width: 1023px) {
    gap: 20px;
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
`

const CompanyDetailGrid: React.FC<ICompanyDetailGrid> = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)
  return (
    <Wrapper>
      <GridStyle>
        {items.map((item, index) => (
          <CompanyDetailCard
            key={index}
            title={item.title}
            count={item.count}
            icon={item.icon}
            isActive={activeIndex === index}
            onClick={() => setActiveIndex(index === activeIndex ? null : index)}
          />
        ))}
      </GridStyle>
    </Wrapper>
  )
}

export { CompanyDetailGrid }
